export const enum ObjectTypesEnum {
    Rect = "rect",
    Circle = "circle",
    Group = "group",
    Text = "text",
    TextBox = "textbox",
    Svg = "svg",
    Ellipse = "ellipse"
}
